import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-alarm-warning-fill',
    badge: 'Immediate Response',
    badgeColor: 'bg-red-100 text-[#DC2626]',
    title: 'Emergency Cleanup',
    desc: 'Rapid deployment within 60 minutes. We contain damage, extract water, and secure your property around the clock.',
    path: '/emergency-cleanup',
    img: 'https://public.readdy.ai/ai/img_res/842cd1f6d641cda40264c63115af8201.jpg',
  },
  {
    icon: 'ri-tools-fill',
    badge: 'Full Restoration',
    badgeColor: 'bg-amber-100 text-amber-700',
    title: 'Property Restoration',
    desc: 'From structural drying to complete rebuild — we restore your property to pre-loss condition with certified precision.',
    path: '/property-restoration',
    img: 'https://readdy.ai/api/search-image?query=property%20restoration%20workers%20repairing%20and%20rebuilding%20interior%20walls%20and%20flooring%20after%20water%20damage%2C%20professional%20construction%20team%2C%20clean%20bright%20workspace&width=600&height=400&seq=svc002&orientation=landscape',
  },
  {
    icon: 'ri-drop-fill',
    badge: 'Pipe & Drainage',
    badgeColor: 'bg-teal-100 text-teal-700',
    title: 'Pipe Leak & Drainage',
    desc: 'Expert pipe leak detection, repair, and full drainage cleaning services to prevent future water damage.',
    path: '/pipe-leak-drainage',
    img: 'https://readdy.ai/api/search-image?query=plumber%20technician%20repairing%20pipe%20leak%20under%20sink%20with%20professional%20tools%2C%20drainage%20cleaning%20equipment%2C%20clean%20white%20background%2C%20professional%20service&width=600&height=400&seq=svc003&orientation=landscape',
  },
  {
    icon: 'ri-search-eye-fill',
    badge: 'Assessment',
    badgeColor: 'bg-indigo-100 text-indigo-700',
    title: 'Damage Assessment',
    desc: 'Thorough inspection using thermal imaging and moisture meters to map the full extent of damage before work begins.',
    path: '/services',
    img: 'https://readdy.ai/api/search-image?query=professional%20inspector%20using%20thermal%20imaging%20camera%20to%20assess%20water%20damage%20in%20building%2C%20moisture%20detection%20equipment%2C%20clean%20professional%20environment&width=600&height=400&seq=svc004&orientation=landscape',
  },
  {
    icon: 'ri-lungs-fill',
    badge: 'Air Quality',
    badgeColor: 'bg-green-100 text-green-700',
    title: 'Mold Remediation',
    desc: 'Safe, certified mold removal and air quality restoration to protect your family and preserve structural integrity.',
    path: '/services',
    img: 'https://readdy.ai/api/search-image?query=mold%20remediation%20specialist%20in%20protective%20suit%20treating%20mold%20on%20walls%20with%20professional%20equipment%2C%20clean%20containment%20area%2C%20professional%20restoration%20service&width=600&height=400&seq=svc005&orientation=landscape',
  },
  {
    icon: 'ri-fire-fill',
    badge: 'Fire & Smoke',
    badgeColor: 'bg-orange-100 text-orange-700',
    title: 'Fire & Smoke Damage',
    desc: 'Complete fire and smoke damage restoration including soot removal, odor elimination, and structural repairs.',
    path: '/services',
    img: 'https://readdy.ai/api/search-image?query=fire%20damage%20restoration%20team%20cleaning%20soot%20and%20smoke%20damage%20from%20walls%20and%20ceiling%2C%20professional%20restoration%20equipment%2C%20clean%20workspace&width=600&height=400&seq=svc006&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-[#DC2626] text-xs font-semibold uppercase tracking-widest">What We Do</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mt-2 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Comprehensive Restoration<br />Solutions
            </h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed max-w-md">
            From the moment disaster strikes to the final coat of paint, our certified team handles every step of the restoration process with precision and care.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="bg-white rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-6">
                <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1 rounded-full mb-3 ${svc.badgeColor}`}>
                  <i className={`${svc.icon} text-xs`}></i>
                  {svc.badge}
                </span>
                <h3 className="text-lg font-bold text-[#1E3A5F] mb-2">{svc.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{svc.desc}</p>
                <Link
                  to={svc.path}
                  className="inline-flex items-center gap-1.5 text-[#DC2626] text-sm font-semibold hover:gap-3 transition-all cursor-pointer"
                >
                  Learn More <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
